import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export const FullScreenAwarePortal = ({ visible, children, htmlElementId }) => {
  const [target, setTarget] = useState(
    document.getElementById(htmlElementId)
  );

  useEffect(() => {
    const onFullscreenChange = () => {
      const fsElem = document.fullscreenElement;

      if (fsElem) {
        setTarget(fsElem);
      } else {
        const original = document.getElementById(htmlElementId);
        setTarget(original);
      }
    };

    document.addEventListener("fullscreenchange", onFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", onFullscreenChange);
    };
  }, [htmlElementId]);

  if (!visible) return null;

  // Safety: if for what ever reason target is missing, do not crash.
  if (!target) return null;

  return createPortal(children, target);
};